import React from 'react';
import MortgageCalculator from './components/MortgageCalculator';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            Mortgage Calculator
          </h1>
          <p className="text-gray-600 text-lg">
            Calculate your monthly payments and total interest
          </p>
        </div>
        <MortgageCalculator />
      </div>
    </div>
  );
}

export default App;